import { render, staticRenderFns } from "./WBtnExport.vue?vue&type=template&id=09b5e0e8&scoped=true&"
import script from "./WBtnExport.vue?vue&type=script&lang=js&"
export * from "./WBtnExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b5e0e8",
  null
  
)

export default component.exports